import { bl_cms_post_comment_login_subject_reaction_link_RowClass } from '../../dbschema/bl_cms_post_comment_login_subject_reaction_link.model';
import { BaseContainerModel } from '../base-container.model';

export class PostCommentLoginSubjectReactionLinksContainerModel extends BaseContainerModel {
  bl_cms_post_comment_login_subject_reaction_link: bl_cms_post_comment_login_subject_reaction_link_RowClass = new bl_cms_post_comment_login_subject_reaction_link_RowClass();
}
